import IconButton from "@material-ui/core/IconButton";
import React from "react";
import { Node } from "react";
export function SocialLink(props: SLinkProps) {
  const { link, icon } = props;
  return (
    <IconButton href={link} edge="start" color="inherit">
      {icon}
    </IconButton>
  );
}
type SLinkProps = {
  icon: Node,
  link: string,
};
